module.exports = __webpack_public_path__ + "img/postgresql.9289b1ec.svg";